{
    "RangeCombo_Search_Placeholder": "Ricerca...",
    "NAME": "RangeComboLanguage"
}